"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _react = _interopRequireWildcard(require("react"));

var _reactJss = _interopRequireDefault(require("react-jss"));

var _clsx = _interopRequireDefault(require("clsx"));

var _reactClickOutside = _interopRequireDefault(require("react-click-outside"));

var _PortalWrapper = _interopRequireDefault(require("../PortalWrapper"));

var _Label = _interopRequireDefault(require("../Label"));

var _utils = _interopRequireDefault(require("../utils/utils"));

var _Autocomplete = _interopRequireDefault(require("./Autocomplete.style"));

var _dec, _class;

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

let Autocomplete = (_dec = (0, _reactJss.default)(_Autocomplete.default), _dec(_class = (0, _reactClickOutside.default)(_class = class Autocomplete extends _react.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      selected: !!props.value,
      passShow: false,
      focus: false,
      error: !!props.value,
      activeItem: -1
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleFocus = this.handleFocus.bind(this);
    this.handleKeyDown = this.handleKeyDown.bind(this);
    this.handleMouseMove = this.handleMouseMove.bind(this);
    this.handleClickRightText = this.handleClickRightText.bind(this);
  }

  static getDerivedStateFromProps(props, state) {
    if (state.selected && !props.value || !state.selected && props.value) {
      return {
        selected: !!props.value
      };
    }

    return null;
  }

  componentDidMount() {
    const {
      autoFocus
    } = this.props;
    if (autoFocus) this.handleFocus();
  } // Handler for click outside of component


  handleClickOutside(e) {
    const el = e.target;
    if (this.txtEl && this.txtEl.contains(el) || this.containerSearchList && this.containerSearchList.contains(el)) return;
    const {
      id,
      value,
      error,
      onBlur,
      onChange
    } = this.props;

    if (!value && !this.input.value) {
      this.setState({
        selected: false
      });
    }

    this.setState({
      focus: false
    });

    if (value && value !== value.trim()) {
      onChange({
        id,
        value: value.trim(),
        error
      });
    }

    onBlur();
  }

  handleFocus() {
    const {
      visibility,
      onFocus
    } = this.props;
    if (visibility !== 'visible') return;
    this.input.focus();
    this.setState({
      selected: true,
      focus: true
    });
    onFocus(this.props.id);
  }

  handleChange(e) {
    const {
      id,
      onChange
    } = this.props;
    const {
      error,
      value
    } = this.formatAndCheck(e.target.value);
    onChange({
      id,
      value,
      error
    });
  }

  handleKeyDown(e) {
    const {
      value,
      onKeyDown
    } = this.props;
    const hotKeys = ['ArrowDown', 'ArrowUp', 'Enter']; // delete

    if (e.key === 'Backspace' && value === '') {
      this.removeChip();
    }

    if (hotKeys.indexOf(e.key) !== -1) {
      this.selectionUsingButtons(e);
    }

    onKeyDown(e);
  }

  handleClickRightText() {
    const {
      onClickRightText
    } = this.props;
    onClickRightText();
  }

  removeChip() {
    const children = this.props.chipsItems();
    if (!children || children.length === 0) return;
    this[`chipRef${children.length - 1}`].props.closeClick();
  }

  selectionUsingButtons(e) {
    e.preventDefault();
    const children = this.props.searchResult();
    if (!children) return;
    const childrenList = children.props.children;
    const {
      activeItem
    } = this.state;
    let newActiveItem = activeItem;

    if (e.key === 'ArrowDown' && activeItem < childrenList.length - 1) {
      newActiveItem += 1;
    } else if (e.key === 'ArrowUp' && activeItem > 0) {
      newActiveItem -= 1;
    }

    if (!childrenList[newActiveItem]) return;
    const item = this[`itemRef${childrenList[newActiveItem].props.id}`];

    if (e.key === 'Enter') {
      const {
        id,
        value,
        avatar,
        visibility
      } = item.props;
      if (visibility === 'disabled') return;
      item.props.onClick({
        id,
        value,
        avatar,
        error: false
      });
      newActiveItem = 0;
    }

    this.setState({
      activeItem: newActiveItem
    }, this.scrollList(_reactDom.default.findDOMNode(item)));
  }

  scrollList(item) {
    const container = _reactDom.default.findDOMNode(this.containerSearchList);

    const heightContainer = container.offsetHeight;
    const heightItem = item.offsetHeight;
    const scrollPosition = item.offsetTop < heightContainer - heightItem * 3 ? 0 : item.offsetTop - (heightContainer - heightItem * 3);

    _utils.default.scrollTo(container, scrollPosition, 100);
  }

  formatAndCheck(value) {
    let error = false;
    const {
      length,
      required
    } = this.props;

    if (!value.length) {
      return {
        error,
        value
      };
    } // Restriction by string length


    if (length && value.length >= length) {
      value = value.substr(0, length);
    }

    if (required && (!value || !value.length)) {
      error = true;
    }

    return {
      error,
      value
    };
  }

  renderChips(chipsItems) {
    const children = chipsItems();
    if (!children) return null;
    return _react.default.Children.map(children, (child, index) => _react.default.cloneElement(child, {
      ref: el => {
        this[`chipRef${index}`] = el;
      }
    }));
  }

  renderRightText(text, classes) {
    if (!text) return null;
    return /*#__PURE__*/_react.default.createElement(_Label.default, {
      value: text,
      className: classes,
      onClick: this.handleClickRightText
    });
  }

  renderHelperText(helperText, classes) {
    if (!helperText) return null;
    return /*#__PURE__*/_react.default.createElement("div", {
      className: classes
    }, helperText);
  }

  handleMouseMove() {
    const {
      activeItem
    } = this.state;

    if (activeItem !== -1) {
      this.setState({
        activeItem: -1
      });
    }
  }

  renderSearchList(searchTitle, searchResult, classes) {
    const {
      portalOptions
    } = this.props;
    const children = searchResult();
    const title = searchTitle();
    const index = this.state.activeItem;
    if (!children) return null;

    const items = /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _clsx.default)(classes, 'searchList'),
      onMouseMove: this.handleMouseMove,
      ref: el => {
        this.containerSearchList = el;
      },
      style: {
        maxHeight: portalOptions && portalOptions.height ? portalOptions.height : 'auto'
      }
    }, title, _react.default.Children.map(children.props.children, child => {
      const activeItem = children.props.children[index] ? children.props.children[index].props.id : null;
      return _react.default.cloneElement(child, {
        ref: el => {
          this[`itemRef${child.props.id}`] = el;
        },
        activeItem
      });
    }));

    if (!portalOptions) return items;
    return /*#__PURE__*/_react.default.createElement(_PortalWrapper.default, (0, _extends2.default)({
      node: this.txtEl,
      width: this.txtEl.clientWidth || 'auto',
      offsetY: this.txtEl.clientHeight - 20 || 0
    }, portalOptions), items);
  }

  render() {
    const {
      classes,
      className,
      id,
      size,
      value,
      visibility,
      label,
      bordered,
      error,
      placeholder,
      helperText,
      rightText,
      onKeyUp,
      onKeyPress,
      chipsItems,
      searchTitle,
      searchResult
    } = this.props;
    const {
      focus,
      selected
    } = this.state;
    const tabIndex = visibility !== 'visible' ? -1 : 0;
    const txtClasses = (0, _clsx.default)(className, classes.autocomplete, classes[size], {
      error: !!error
    }, {
      hidden: visibility === 'hidden'
    }, {
      disabled: visibility === 'disabled'
    }, {
      focus: !!focus
    }, {
      selected: !!selected || chipsItems
    }, {
      bordered
    });
    const helperTextClasses = (0, _clsx.default)(classes.helperText, {
      error
    });
    const searchListClasses = classes.searchList;
    const rightTextClasses = (0, _clsx.default)(classes.rightText, 'rightText');
    const chipsClasses = 'chipsContainer';
    return /*#__PURE__*/_react.default.createElement("div", {
      id: id,
      className: txtClasses,
      ref: el => {
        this.txtEl = el;
      }
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _clsx.default)(classes.label, 'label')
    }, label), /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _clsx.default)(classes.field, 'field')
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: classes.fieldInput
    }, this.renderChips(chipsItems, chipsClasses), /*#__PURE__*/_react.default.createElement("input", {
      ref: el => this.input = el,
      value: value,
      onFocus: this.handleFocus,
      onChange: this.handleChange,
      autoComplete: "off",
      disabled: visibility === 'disabled',
      tabIndex: tabIndex,
      placeholder: placeholder,
      onKeyPress: onKeyPress,
      onKeyDown: this.handleKeyDown,
      onKeyUp: onKeyUp
    })), this.renderRightText(rightText, rightTextClasses)), this.renderHelperText(helperText, helperTextClasses), this.renderSearchList(searchTitle, searchResult, searchListClasses));
  }

}) || _class) || _class);
Autocomplete.defaultProps = {
  visibility: 'visible',
  size: 'medium',
  error: false,
  bordered: false,
  chipsItems: null,
  searchResult: null,
  onChange: () => {},
  onFocus: () => {},
  onBlur: () => {},
  onClickRightText: () => {},
  onKeyPress: () => {},
  onKeyUp: () => {},
  onKeyDown: () => {},
  searchTitle: () => {}
};
var _default = Autocomplete;
exports.default = _default;